import { makeStateKey } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { CacheRef, resolverSSGFirst } from './ssg-first.utils';
import type { PaginaEntry } from '@core/interfaces/modyo';

const STATE_KEY = makeStateKey<PaginaEntry>('pagina-bienvenida');
const cache: CacheRef<PaginaEntry> = { valor: null };

export const resetCacheClienteBienvenida = (): void => {
  cache.valor = null;
};

export const bienvenidaResolver: ResolveFn<PaginaEntry | null> = (): Observable<PaginaEntry | null> =>
  resolverSSGFirst({ stateKey: STATE_KEY, cache, rutaSsg: 'bienvenida', uidTipo: 'pagina', slug: 'paginabienvenida' });
